import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import { Layout, Logo } from "@prestosports/commons-ui";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useAppContext } from "../../../state/app/context";
import { useAuthContext } from "../../../state/authentication/context";
import Routes from "../../../routes/Routes";
import { AppRoutes } from "../../../routes/app-routes";

const LayoutContainer = () => {
	const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const { state: appContextState } = useAppContext();
	const appRoutes = appContextState.appRoutes();
	const menuItems = appContextState.menuItems();
	const { state, logout } = useAuthContext();

	const profile = state.profile();
	const isAuthenticated = state.isAuthenticated();

	const location = useLocation();
	const enableMenu =
		Object.values(appRoutes).filter(
			(route) =>
				route.showMenu &&
				matchPath(
					{
						path: route.url,
						exact: true,
						strict: true
					},
					location.pathname
				)
		).length > 0;

	const selectedSport = appContextState.selectedSport();
	const sportAccess = appContextState.sportAccess();
	const selectedSportName = sportAccess?.find((sport) =>
		selectedSport?.includes(sport.value)
	)?.name;

	return (
		<Layout
			appTitle="Prestostats"
			appSubtitle={selectedSportName}
			isAuthenticated={isAuthenticated}
			enableMenu={enableMenu}
			userInfo={profile}
			menuItems={menuItems}
			logoutFx={logout}
			router={<Routes routeConfig={AppRoutes} />}
			menuIcon={<Logo />}
			hideLogo={isMobile}
		/>
	);
};

export default LayoutContainer;
